module.exports = __webpack_public_path__ + "img/scenario-gunfight.ec4ec5e.svg";